import { ValidationResult, ValidatorOptions } from ".";

export const required = (value: unknown, options: ValidatorOptions = {}): ValidationResult<unknown> => {
    const { fieldName = 'Field' } = options;
    const isValid = value !== null && value !== undefined && value !== '';

    return {
        isValid,
        value: isValid ? value : null,
        errors: isValid ? [] : [{
            code: 'missing_data',
            message: `${fieldName} is required`,
            field: fieldName
        }]
    };
};

export const requiredParameter = (parameter: {id: string, value: unknown}, options: ValidatorOptions = {}): ValidationResult<{id: string, value: unknown}> => {
    const { fieldName = 'Field' } = options;
    const isValid = 
    parameter !== null
    && parameter !== undefined 
    && parameter.value !== '' 
    && parameter.value !== null 
    && parameter.value !== undefined;

    return {
        isValid,
        value: isValid ? parameter : null,
        errors: isValid ? [] : [{
            code: 'missing_data',
            message: `${fieldName} is required`,
            field: fieldName
        }]
    };
}

export const isString = (value: unknown, options: ValidatorOptions = {}): ValidationResult<string> => {
    const { fieldName = 'Field' } = options;
    const isValid = typeof value === 'string';

    return {
        isValid,
        value: isValid ? value as string : null,
        errors: isValid ? [] : [{
            code: 'invalid_type',
            message: `${fieldName} must be a string`,
            field: fieldName
        }]
    };
};

export const isNumber = (value: unknown, options: ValidatorOptions = {}): ValidationResult<number> => {
    const { fieldName = 'Field' } = options;
    const isValid =
        typeof value === 'number' ||
        (typeof value === 'string' && !isNaN(Number(value)));

    return {
        isValid,
        value: isValid ? Number(value) : null,
        errors: isValid ? [] : [{
            code: 'invalid_type',
            message: `${fieldName} must be a number`,
            field: fieldName
        }]
    };
};

export const isBoolean = (value: unknown, options: ValidatorOptions = {}): ValidationResult<boolean> => {
    const { fieldName = 'Field' } = options;
    const isValid =
        typeof value === 'boolean' ||
        value === 'true' ||
        value === 'false';

    return {
        isValid,
        value: isValid
            ? (typeof value === 'boolean' ? value : value === 'true')
            : null,
        errors: isValid ? [] : [{
            code: 'invalid_type',
            message: `${fieldName} must be a boolean`,
            field: fieldName
        }]
    };
};